import React from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { mergeStyles } from '@enlyt/helpers/mergeStyles'

import { getExternalLinks } from 'stores/Links/Select'
import { localization } from './localization'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import withLocalization from '@web/helpers/localizationUtils'

const AuthFooter = props => {
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, props.style)
  const { t } = props
  const OtherContent = _.get(useSelector(getExternalLinks), 'OtherContent', {})
  return (
    <div style={styles.container}>
      <div style={styles.text}>
        <span>{`${t('allright')} `}</span>
        <a style={styles.link} href={_.get(OtherContent, 'UFD_Terms_of_Use', 'https://www.choc.org/mychoc-terms')} target="_blank" rel="noreferrer">{t('termsOfUse')}</a>
        <span>{` ${t('and')} `}</span>
        <a style={styles.link} href={_.get(OtherContent, 'UFD_Privacy_Policy', 'https://www.choc.org/privacy')} target="_blank" rel="noreferrer">{t('privacyPolicy')}</a>
      </div>
    </div>
  )
}

export default withLocalization(AuthFooter, localization)
